import React, { Suspense } from 'react';
import { predefinedHostname, userInCustomHostnameUrlList } from '@ocr-gateway/shared';
import { RootStateOrAny, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes } from './Routes';
import { predefinedHostnameRoutes } from '../constants';

export const HostnameWrapper = ({ children }: { children: React.ReactNode }) => {
  const { authWasInitialized, userId: loggedUserId } = useSelector((state: RootStateOrAny) => ({
    userId: state.auth.user.id,
    authWasInitialized: state.auth.authWasInitialized
  }));

  return (
    <>
      {predefinedHostname &&
      (!authWasInitialized || !loggedUserId || userInCustomHostnameUrlList) ? (
        <Router>
          <Suspense fallback={<div>Loading...</div>}>
            <Routes routes={predefinedHostnameRoutes} />
          </Suspense>
        </Router>
      ) : (
        children
      )}
    </>
  );
};
